import { useState, useCallback } from "react";
import { ProductService } from "../../../services/ProductService.js";

const productService = new ProductService();

const useTiposProducto = (baseUrl, empresa, nombreEmpresa) => {
  const [tipoProductoOptions, setTipoProductoOptions] = useState([]);

  const fetchTipoProductoByEmpresa = useCallback(async () => {
    try {
      const tipos = await productService.getTiposProductoByEmpresa(baseUrl, nombreEmpresa);
      setTipoProductoOptions(tipos);
    } catch (error) {
      console.error("Error fetching tipo_producto:", error);
    }
  }, [baseUrl, nombreEmpresa]);

  return { tipoProductoOptions, fetchTipoProductoByEmpresa };
};

export default useTiposProducto;
